import { jsx as l } from "react/jsx-runtime";
const r = (o) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 64 64",
    ...o,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        d: "m36.851 30.872-1.93.522 6.684 24.734 1.93-.522-6.684-24.734ZM27.15 30.866l-6.685 24.733 1.93.522 6.685-24.734-1.93-.521ZM36.614 24.438l.054-.014h-8.715V22.74c0-.282.23-.511.512-.511h7.695c.283 0 .512.23.512.511v1.683l4-1.072v-.61c0-1.654-.894-3.101-2.223-3.887V5.074H26.176v13.78a4.513 4.513 0 0 0-2.223 3.887v5.683h13.729l-1.068-3.986ZM30.176 9.075h4.273v9.154h-4.273V9.075Z"
      }
    )
  }
);
export {
  r as StrobeLights2
};
